import React from "react";
import { Box,Button, Fab } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { useTheme } from "@emotion/react";
import { tokens } from "../../../theme";
import { accountsmanagement, HRService } from "../../../config";
// Router hooks are still imported but the logic is commented out,
// so we'll leave them here in case the standalone page logic is needed later.
// import { useParams, useLocation } from 'react-router-dom';

// NOTE: You need to create an array of columns that contains ONLY the fields you want to show.
// *** NOTE: You MUST create a new columns definition for Fee Note Lines. ***
import { imprestLinesColumns, purchaseInvoiceLinesColumns} from "../../../data/DynamicTable/Collumns"; 
//import { allRelievers } from "../../../data/Columns/hrmanagement"; 

// *** FIX: Import the appropriate query (e.g., allFeeNotesLinesQuery if it exists) ***
import { allFeeNotesLinesQuery, allImprestLinesQuery } from "../../../data/Axios/queries"; 
import { useNavigate, useLocation } from "react-router-dom";
import { staffClaimLinesColumns } from "../../../data/Columns/hrmanagement";
import StaffClaimApplicationLineForm from "./claimLineForm";

const base_url = HRService.uri;

/**
 * Component to display Fee Note Lines associated with a parent Fee Note.
 */
function ClaimApplicationLines() {
     const location = useLocation();
     // Retrieve data using the key for Fee Notes
     const data = 
        location.state?.claimData ||
        JSON.parse(localStorage.getItem("ClaimData"));

     const theme = useTheme();
     const colors = tokens(theme.palette.mode);
     const navigate = useNavigate();

     const handleGoBack = () => {
     const backPath = location.state?.from || "/imprest-applications";
        navigate(backPath);
     };

     // Check if parent data is available before proceeding
     if (!data || !data.id) {
        return (
            <Box m="2px" p="1rem">
                <p>Error: Parent purchase invoice data not found in local storage.</p>
            </Box>
        );
     }
     
     const ApplicationId = data.id;
     // Define actions for Fee Note Lines
     const actions = {
        require : "id",
         entity: "Claim Line",
         edit: {
             key: "EDIT",
             button_name: "Edit Line",
             Show_Button: true, 
             permission: "hasNoPermission", 
            roleGroupId: [1, 2, 3, 4], 
         },
         add: {
             key: "ADD",
             button_name: "Add",
             Show_Button: true, 
             permission: "hasNoPermission", 
            roleGroupId: [1, 2, 3, 4], 
         },
         showStatus: false,
         
         // *** UPDATE: Set modelName to match the GraphQL operation name (without 'query') ***
         modelName: "claimApplicationLinesByImprestId", 
         dataObject: {
             // *** UPDATE: The input field must match the GraphQL variable (feeNotesLines) ***
             inputFields: {
              
                applicationId: ApplicationId,
                
            
            },
             
             // *** UPDATE: inputObjectName matches the GraphQL operation name (without 'query') ***
             inputObjectName: "claimApplicationLinesByImprestId", 
             
             // *** UPDATE: inputSubObjectName is the array of results returned by the operation ***
             // Assuming the results array is directly returned by the operation.
             // If the API nests the array under another field, change this accordingly.
             inputSubObjectName: "claimApplicationLines", // Often the same as inputObjectName if the array is directly returned.
             
             returnFields: [
                "id",
                "companyId",
                "applicationId",
                "expenseTypeId",
                "accountId",
                "description",
                "isActive",
                "amount",
                "supportingDocument",
                "createdDate",
                "createdBy",
                "updatedDate",
                "updatedBy"
             ],
         },
     };

     const title = `Staff Claims Lines ${data.documentNumber || data.id}`;
     const subtitle = `View All Lines for this Claim`;

     return (
        <Box m="2px" p="1rem">
           {/* Floating Back Button */}
            <Fab
                color="secondary"
                aria-label="go back"
                onClick={handleGoBack}
                sx={{
                    position: "fixed",
                    top: 120,      
                    left: 270,     
                    zIndex: 1100,
                    width: 40,
                    height: 40,
                    boxShadow: 3,
                    "&:hover": {
                    boxShadow: 6,
                    },
                }}
            >
                <ArrowBackIcon />
            </Fab>

            <DynamicTable
                title={title}
                subtitle={subtitle}
                // *** NOTE: Replace 'allRelievers' with your actual columns array (e.g., feeNoteLinesColumns) ***
                columns={staffClaimLinesColumns} 
                // *** NOTE: Replace 'allUsersQuery' with the actual query that fetches fee note lines (e.g., allFeeNotesLinesQuery) ***
                //query={allImprestLinesQuery}
                FormComponent={StaffClaimApplicationLineForm}
                base_url={base_url}
                actions={actions}
             />
        </Box>
     );
}

export default ClaimApplicationLines;